import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { useAudio } from './AudioRef';

/**
 * 结束页组件（Slide 12）
 * 显示 THANK YOU 和课程完成动画
 */
function PhonicsThanks({ mediaBase }) {
  const [audioPlaying, setAudioPlaying] = useState(false);
  const audio = useAudio();

  // 组件卸载时停止音频
  React.useEffect(() => {
    return () => audio.stop();
  }, []);

  const playThanks = () => {
    audio.play(`${mediaBase}/audio_instruction_thanks.mp3`, () => setAudioPlaying(false));
    setAudioPlaying(true);
  };

  return (
    <div className="phonics-thanks">
      <div className="phonics-thanks-text">THANK YOU!</div>
      <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        <Typography sx={{ color: '#2EC4B6', fontWeight: 600, fontSize: 26 }}>
          谢谢
        </Typography>
        <button
          className={`phonics-audio-btn phonics-instruction-btn ${audioPlaying ? 'playing' : ''}`}
          onClick={playThanks}
          title="播放：谢谢"
        >
          <VolumeUpIcon sx={{ fontSize: 18 }} />
        </button>
      </Box>
      <Box sx={{ mt: 2, fontSize: 48, animation: 'bounce-in 0.6s ease 0.3s both' }}>
        <EmojiEventsIcon sx={{ fontSize: 64, color: '#FFBF69' }} />
      </Box>
      <Box sx={{ mt: 3, display: 'flex', gap: 1, justifyContent: 'center' }}>
        {'⭐⭐⭐'.split('').map((star, i) => (
          <span key={i} style={{ fontSize: 36, animation: `bounce-in 0.4s ease ${0.5 + i * 0.15}s both` }}>
            {star}
          </span>
        ))}
      </Box>
    </div>
  );
}

export default PhonicsThanks;